var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldConfigActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.9839V19.9998M16 18.9839C15.1003 18.9839 14.3077 18.535 13.8427 17.8533M16 18.9839C16.8998 18.9839 17.6924 18.535 18.1574 17.8533M13.8427 17.8533L12.8893 18.476M13.8427 17.8533C13.5678 17.4501 13.4074 16.9655 13.4074 16.4442C13.4074 15.923 13.5677 15.4384 13.8426 15.0353M18.1574 17.8533L19.1108 18.476M18.1574 17.8533C18.4323 17.4501 18.5926 16.9655 18.5926 16.4442C18.5926 15.923 18.4324 15.4384 18.1574 15.0353M16 13.9046C16.8998 13.9046 17.6926 14.3536 18.1574 15.0353M16 13.9046C15.1002 13.9046 14.3075 14.3536 13.8426 15.0353M16 13.9046V12.8887M18.1574 15.0353L19.1111 14.4125M13.8426 15.0353L12.8889 14.4125",
    stroke: "#6929E2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88892 4H19.1111",
    stroke: "#BEA5EF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88892 9.33398H19.1111",
    stroke: "#BEA5EF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88892 14.666H9.33336",
    stroke: "#BEA5EF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldConfigActive);
export default __webpack_public_path__ + "static/media/field-config-active.798aeb6d9db3b2c977fd5049e3bc654f.svg";
export { ForwardRef as ReactComponent };